import { useState } from 'react';
import { FiSearch, FiFilter } from 'react-icons/fi';
import { FaSortAmountDown } from 'react-icons/fa';

import { DataSourceTab } from '../../components/AiRecruiter/DataSourceTab';
import { DocumentTab } from '../../components/AiRecruiter/DocumentTab';
import { QuestionaireTab } from '../../components/AiRecruiter/QuestionaireTab';
import CandidatesTab from '../../components/AiRecruiter/CandidatesTab';
import IntakeFormsTab from '../../components/AiRecruiter/IntakeFormsTab';
import PageLayout from '../../layouts/PageLayout';
import AddJob from '../../components/AiRecruiter/AddJob';

export default function AiRecruiter() {
  const [activeTab, setActiveTab] = useState(0);
  const [openModal, setOpenModal] = useState(false);

  const tabItems = [
    { label: 'DataSource', component: <DataSourceTab /> },
    { label: 'Recruiter Agent', component: <CandidatesTab /> },
    { label: 'Questionaire', component: <QuestionaireTab /> },
    { label: 'Documents', component: <DocumentTab /> },
    { label: 'Application Forms', component: <IntakeFormsTab /> },
  ];

  return (
    <PageLayout
      pageTitle="Recruiter Agent"
      actionButton={
        <button
          onClick={() => setOpenModal(true)}
          className="bg-gradient-to-r from-[#A281FF] to-[#D297CE] hover:from-[#6E3EF5] hover:to-[#A818D8] flex items-center justify-center px-4 py-2 text-sm font-inter rounded-md text-white gap-2 hover:scale-105 hover:shadow-md transition-transform duration-150"
        >
          Add Role
        </button>
      }
    >
      <div className="font-sans h-full flex flex-col px-4 sm:px-6 md:px-6 w-full py-6">
        <div className="bg-white rounded-xl shadow-lg shadow-[#F8F5FF] p-4 sm:p-6 md:p-8 w-full  border-[#D4D4D4] border-[0.5px]">
          {/* Tab headers */}
          <div className="overflow-x-auto hide-scrollbar">
            <div className="flex min-w-max border-b-[0.5px] border-[#D4D4D4] gap-6 sm:gap-8 md:gap-10 hide-scrollbar">
              {tabItems.map((tab, i) => (
                <button
                  key={tab.label}
                  onClick={() => setActiveTab(i)}
                  className={`px-2 sm:px-4 md:px-5 pb-2 whitespace-nowrap border-b-[0.5px] transition-all duration-150 text-sm sm:text-base hide-scrollbar ${
                    activeTab === i
                      ? 'border-[#6E3EF5] text-black font-semibold'
                      : 'border-transparent text-[#272727] hover:text-[#232222]'
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          {/* Tab content */}
          <div className="flex flex-col gap-4 sm:gap-6 w-full py-4">
            {tabItems[activeTab]?.component}
          </div>
        </div>
      </div>

      <AddJob open={openModal} onClose={() => setOpenModal(false)} />
    </PageLayout>
  );
}
